// React Query mutations for AI-powered email generation

import { useApiClient } from '@commander/api-client';
import { useMutation } from '@tanstack/react-query';
import { createEmailAiApi } from '../../api/emailAiApi';
import type { AiGenerationCreateData } from '../../types/aiGeneration';

/**
 * Hook to generate email content with AI
 * Returns mutation function to trigger generation and track status
 */
export function useGenerateEmail() {
  const apiClient = useApiClient();
  const emailAiApi = createEmailAiApi(apiClient);

  return useMutation({
    mutationFn: (data: AiGenerationCreateData) => emailAiApi.generateEmail(data),
  });
}
